import React, { useState, useEffect } from "react";
import "../styles/main.css";
const images = [
  {
    src: "./assets/cashew_banner_1_web.png",
    mobileSrc: "./assets/cashew_banner_1_mob.png",
    alt: "MSk Native Naturals - Premium Roasted Cashew Nuts",
    title: "",
    description: "",
  },
  {
    src: "./assets/cashew_banner_2_web.png",
    mobileSrc: "./assets/cashew_banner_2_mob.png",
    alt: "MSk Native Naturals - Roasted & Salted Perfection",
    title: "",
    description: "",
  },
  {
    src: "./assets/cashew_banner_3_web.png",
    mobileSrc: "./assets/cashew_banner_3_mob.png",
    alt: "MSk Native Naturals - 100% Pure & Farm Fresh Cashews",
    title: "",
    description: "",
  }
];

const INTERVAL = 5000;

const Home = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % images.length);
    }, INTERVAL);

    return () => clearInterval(timer);
  }, []);

  return (
    <div id="homeCarousel" className="carousel slide carousel-fade vk-carousel">
      <div className="carousel-inner vk-inner">
        {images.map((img, idx) => (
          <div
            key={idx}
            className={`carousel-item ${idx === activeIndex ? "active" : ""}`}
          >
            <picture>
              <source srcSet={img.mobileSrc} media="(max-width: 768px)" />
              <img
                src={img.src}
                className="vk-img"
                alt={img.alt}
                loading={idx === 0 ? "eager" : "lazy"}
              />
            </picture>

            {(img.title || img.description) && (
              <div className="vk-caption">
                {img.title && <h5 className="vk-title">{img.title}</h5>}
                {img.description && <p className="vk-desc">{img.description}</p>}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="carousel-indicators vk-dots">
        {images.map((_, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => setActiveIndex(idx)}
            className={idx === activeIndex ? "active" : ""}
            aria-label={`Slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Home;